import type { Messages } from '@ah/i18n';

/** Greek — primary/default locale (ADR-015). Source of truth: a missing `en` key falls back here. */
export const el: Messages = {
  auth: {
    login: {
      title: 'Σύνδεση θεραπευτή',
      email: 'Email',
      password: 'Κωδικός',
      submit: 'Σύνδεση',
      submitting: 'Σύνδεση…',
      missingFields: 'Παρακαλούμε συμπλήρωσε email και κωδικό.',
      twoFactorUnsupported: 'Η επιβεβαίωση δύο βημάτων δεν υποστηρίζεται για αυτόν τον τύπο λογαριασμού. Επικοινώνησε με την υποστήριξη.',
      wrongPortal: 'Αυτή η πύλη είναι μόνο για θεραπευτές. Συνδέσου με λογαριασμό θεραπευτή.',
      failed: 'Η σύνδεση απέτυχε. Δοκίμασε ξανά.',
      noAccount: 'Νέος/α θεραπευτής στο Anonymous Help;',
      registerLink: 'Εγγραφή',
    },
    register: {
      title: 'Εγγραφή ως θεραπευτής',
      intro: 'Ο λογαριασμός σου ελέγχεται πριν αντιστοιχιστείς με πελάτες — μπορείς να συνδεθείς και να εξερευνήσεις την πύλη στο μεταξύ.',
      email: 'Email',
      password: 'Κωδικός (min 10 χαρακτήρες, κεφαλαία/πεζά + αριθμός)',
      displayName: 'Όνομα εμφάνισης',
      displayNamePlaceholder: 'π.χ. Δρ. Μαρία Παπαδοπούλου',
      licenseNumber: 'Αριθμός άδειας',
      licenseCountry: 'Χώρα άδειας (κωδικός 2 γραμμάτων)',
      specialties: 'Ειδικότητες (χωρισμένες με κόμμα)',
      specialtiesPlaceholder: 'π.χ. άγχος, τραύμα, σχέσεις',
      specialtiesError: 'Γράψε τουλάχιστον μία ειδικότητα, χωρισμένες με κόμμα.',
      failed: 'Η εγγραφή απέτυχε. Δοκίμασε ξανά.',
      legalNoticePrefix: 'Με την εγγραφή σου αποδέχεσαι τους',
      legalNoticeJoiner: 'και την',
      termsLink: 'Όρους Χρήσης',
      privacyLink: 'Πολιτική Απορρήτου',
      alreadyRegistered: 'Έχεις ήδη λογαριασμό;',
      loginLink: 'Σύνδεση',
      submit: 'Δημιουργία λογαριασμού θεραπευτή',
      submitting: 'Δημιουργία λογαριασμού…',
    },
  },
  dashboard: {
    title: 'Πύλη θεραπευτή',
    myProfile: 'Το προφίλ μου',
    payouts: 'Πληρωμές',
    settings: 'Ρυθμίσεις',
    signOut: 'Αποσύνδεση',
    pendingReview: 'Ο λογαριασμός σου βρίσκεται υπό έλεγχο — μπορείς να εξερευνήσεις την πύλη τώρα, αλλά δεν θα αντιστοιχιστείς με πελάτες μέχρι να εγκριθεί από διαχειριστή.',
    suspended: 'Ο λογαριασμός σου έχει ανασταλεί. Επικοινώνησε με έναν διαχειριστή για λεπτομέρειες.',
    rejected: 'Η αίτησή σου δεν εγκρίθηκε. Επικοινώνησε με έναν διαχειριστή για λεπτομέρειες.',
    loading: 'Φόρτωση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των κρατήσεών σου.',
    yourBookings: 'Οι κρατήσεις σου',
    noBookings: 'Δεν υπάρχουν κρατήσεις ακόμα.',
    working: 'Επεξεργασία…',
    accept: 'Αποδοχή',
    decline: 'Απόρριψη',
    declinePrompt: 'Αιτιολογία απόρριψης (προαιρετικό):',
    acceptError: 'Δεν ήταν δυνατή η αποδοχή της κράτησης. Δοκίμασε ξανά.',
    declineError: 'Δεν ήταν δυνατή η απόρριψη της κράτησης. Δοκίμασε ξανά.',
    awaitingPayment: 'Αναμονή πληρωμής πελάτη.',
    openCall: 'Έναρξη κλήσης',
  },
  payouts: {
    title: 'Πληρωμές',
    backDashboard: '← Πίνακας',
    connectStatusTitle: 'Κατάσταση Stripe Connect',
    onboarded: '✅ Οι πληρωμές έχουν ρυθμιστεί — θα λαμβάνεις το 90% κάθε κράτησης, με εβδομαδιαία εκκαθάριση.',
    notFullySetUp: 'Ο λογαριασμός σου Stripe δεν έχει ολοκληρωθεί ακόμα — ολοκλήρωσε την εγγραφή για να λαμβάνεις πληρωμές.',
    notConnected: 'Δεν έχεις συνδέσει ακόμα λογαριασμό πληρωμών.',
    completeOnboarding: 'Ολοκλήρωση εγγραφής Stripe',
    redirecting: 'Μεταφορά…',
    onboardingError: 'Δεν ήταν δυνατή η έναρξη της εγγραφής.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των στοιχείων πληρωμών.',
    payoutHistory: 'Ιστορικό πληρωμών',
    noPayouts: 'Δεν υπάρχουν πληρωμές ακόμα.',
    bookingsSuffix: 'κράτηση/εις',
    net: 'καθαρό',
  },
  settings: {
    title: 'Ρυθμίσεις λογαριασμού',
    backDashboard: '← Πίνακας',
    language: 'Γλώσσα',
    deleteAccount: 'Διαγραφή λογαριασμού',
    scheduledFor: 'Ο λογαριασμός σου έχει προγραμματιστεί για διαγραφή στις {{date}}. Μπορείς να το ακυρώσεις οποιαδήποτε στιγμή πριν από τότε.',
    cancelling: 'Ακύρωση…',
    cancelRequest: 'Ακύρωση αιτήματος διαγραφής',
    graceNotice: 'Αυτό ξεκινά μια περίοδο χάριτος {{days}} ημερών κατά την οποία μπορείς να ακυρώσεις. Μετά από αυτό, το δημόσιο προφίλ, τα μηνύματα και τα στοιχεία σύνδεσής σου ανωνυμοποιούνται μόνιμα. Βεβαιώσου ότι δεν έχεις επερχόμενες κρατήσεις και έχεις επικοινωνήσει με την υποστήριξη για τυχόν εκκρεμή πληρωμή πρώτα — τα αρχεία κρατήσεων και τιμολογίων διατηρούνται όπως απαιτείται από τη φορολογική νομοθεσία, αποσυνδεδεμένα από την ταυτότητά σου. Εισήγαγε τον κωδικό σου για επιβεβαίωση.',
    password: 'Κωδικός',
    submitting: 'Υποβολή…',
    confirmDeletion: 'Επιβεβαίωση διαγραφής',
    cancel: 'Ακύρωση',
    deleteMyAccount: 'Διαγραφή λογαριασμού μου',
    deletionRequestError: 'Δεν ήταν δυνατή η υποβολή του αιτήματος διαγραφής.',
    deletionCancelError: 'Δεν ήταν δυνατή η ακύρωση του αιτήματος διαγραφής.',
  },
  profile: {
    title: 'Το προφίλ μου',
    backDashboard: '← Πίνακας',
    intro: 'Αυτό βλέπουν οι πελάτες στην αρχική σελίδα: φωτογραφία, τίτλο, βιογραφικό, βίντεο παρουσίασης, ειδικότητες και τα περιστατικά που αναλαμβάνεις.',
    loading: 'Φόρτωση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση του προφίλ σου.',
    photo: 'Φωτογραφία προφίλ',
    photoUpdated: 'Η φωτογραφία ενημερώθηκε.',
    photoUploadFailed: 'Το ανέβασμα απέτυχε.',
    tabEl: 'Ελληνικά',
    tabEn: 'English',
    requiredBadge: 'υποχρεωτικό',
    optionalBadge: 'προαιρετικό',
    completeBadge: '✓ πλήρες',
    incompleteBadge: 'ελλιπές',
    headlineLabel: 'Τίτλος (π.χ. «Κλινική Ψυχολόγος, 12 χρόνια εμπειρίας»)',
    bioLabel: 'Βιογραφικό / περιγραφή',
    introVideoLabel: 'Βίντεο παρουσίασης (σύνδεσμος YouTube/Vimeo — προαιρετικό, κοινό και για τις δύο γλώσσες)',
    categoriesLegend: 'Κατηγορίες (ειδικότητες — επίλεξε από τη λίστα, κοινές και για τις δύο γλώσσες)',
    caseTagsLabel: 'Περιστατικά που αναλαμβάνω (tags, χωρισμένα με κόμμα)',
    caseTagsPlaceholderEl: 'π.χ. κρίσεις πανικού, πένθος, burnout',
    caseTagsPlaceholderEn: 'e.g. panic attacks, grief, burnout',
    spokenLanguagesLegend: 'Γλώσσες συνεδρίας (σε ποιες γλώσσες μπορείς να κάνεις τη συνεδρία)',
    save: 'Αποθήκευση προφίλ',
    saving: 'Αποθήκευση…',
    saveSuccess: 'Το προφίλ αποθηκεύτηκε — φαίνεται άμεσα στην αρχική σελίδα (εφόσον είσαι εγκεκριμένος).',
    saveFailed: 'Η αποθήκευση απέτυχε.',
  },
  call: {
    connecting: 'Σύνδεση…',
    waitingForOther: 'Αναμονή για τον πελάτη…',
    ending: 'Τερματισμός κλήσης…',
    ended: 'Η κλήση τερμάτισε — {{duration}}',
    anonymousNotice: 'Ανώνυμη κλήση — η φωνή σου είναι αλλοιωμένη, η κάμερα είναι απενεργοποιημένη.',
    mute: 'Σίγαση',
    unmute: 'Άρση σίγασης',
    endCall: 'Τερματισμός κλήσης',
    done: 'Τέλος',
    back: 'Πίσω',
    genericError: 'Κάτι πήγε στραβά.',
    needSignIn: 'Χρειάζεται να συνδεθείς για να μπεις σε αυτή την κλήση.',
    joinError: 'Δεν ήταν δυνατή η σύνδεση στην κλήση.',
  },
};
